module.exports = __webpack_public_path__ + "static/media/ipadiphone-new.a3e563db.png";